function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from "react";
import { Platform, StyleSheet, TextInput, View } from "react-native";
import { Kind } from "@oui/lib/src/types";
import { Icon } from "./Icon";
import { Text } from "./Text";
import { getStyles } from "./TextInput";
import { useTheme } from "../styles";
/**
 * A `ChatInput` variant that allows user to submit freeform text.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-63}
 */ export function ChatInputText(_param) {
    var _param_onInput = _param.onInput, onInput = _param_onInput === void 0 ? function() {} : _param_onInput, _param_disabled = _param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, props = _object_without_properties(_param, [
        "onInput",
        "disabled"
    ]);
    var theme = useTheme().theme;
    var inputRef = useRef(null);
    var focusTimeoutRef = useRef(0);
    var _useState = _sliced_to_array(useState({
        isFocused: false,
        value: null,
        valid: false
    }), 2), state = _useState[0], setState = _useState[1];
    useEffect(function() {
        // Not sure why the autoFocus prop on TextInput isn't working as expected,
        // but we seem to need a short delay to get the focus to actually take effect
        if (props.autoFocus) {
            focusTimeoutRef.current = global.setTimeout(function() {
                if (inputRef.current) {
                    inputRef.current.focus();
                }
            }, 100);
        }
        return function() {
            return clearTimeout(focusTimeoutRef.current);
        };
    }, [
        props.autoFocus
    ]);
    var emit = useCallback(function(value) {
        if (onInput) {
            onInput({
                kind: Kind.InputText,
                props: value.trim()
            });
        }
    }, [
        onInput
    ]);
    var handleInput = useCallback(function(param) {
        var next = param.value;
        var curr = state.value;
        if (curr !== next) {
            setState(function(curr) {
                return _object_spread_props(_object_spread({}, curr), {
                    value: next,
                    valid: next !== ''
                });
            });
        }
    }, [
        state
    ]);
    var handleSubmit = useCallback(function() {
        console.log('submit');
        var curr = state.value, valid = state.valid;
        if (curr !== null && valid) {
            emit(curr);
            setState(function(curr) {
                return _object_spread_props(_object_spread({}, curr), {
                    value: null,
                    valid: false
                });
            });
            if (inputRef.current) inputRef.current.blur();
        }
    }, [
        state,
        emit
    ]);
    var value = state.value, valid = state.valid;
    var change = function(text) {
        return handleInput({
            value: text
        });
    };
    var submit = function() {
        return handleSubmit();
    };
    // Due to existing RN issue, we need to customize our TextInput behavior on Android
    // otherwise when our TextInput has a value, the lastTextContent won't be read by TalkBack.
    // Usually, we can get around this using the placeholder attribute, but in this case our
    // the placeholder is the last chat message which is likely too long to fit without wrapping
    // and expanding our text box.
    // https://github.com/facebook/react-native/issues/26739
    var inner = /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(TextInput, {
                importantForAccessibility: "no-hide-descendants",
                "aria-label": props.lastTextContent,
                testID: "ChatInputText_input",
                ref: inputRef,
                keyboardType: props.keyboardType,
                style: [
                    getStyles(theme).outlined,
                    {
                        flex: 1,
                        paddingRight: 40,
                        height: '100%'
                    },
                    disabled ? {
                        opacity: 0.5
                    } : null
                ],
                value: value || '',
                onChangeText: change,
                onSubmitEditing: valid ? submit : undefined,
                onFocus: function() {
                    return setState(function(curr) {
                        return _object_spread_props(_object_spread({}, curr), {
                            isFocused: true
                        });
                    });
                },
                onBlur: function() {
                    return setState(function(curr) {
                        return _object_spread_props(_object_spread({}, curr), {
                            isFocused: false
                        });
                    });
                },
                enterKeyHint: "send",
                readOnly: disabled,
                multiline: true,
                // @ts-expect-error web only
                rows: Platform.OS === 'web' ? '1' : undefined
            }),
            disabled || (value === null || value === void 0 ? void 0 : value.length) ? null : /*#__PURE__*/ _jsx(View, {
                style: [
                    StyleSheet.absoluteFillObject,
                    {
                        justifyContent: 'center',
                        paddingLeft: 16
                    }
                ],
                pointerEvents: "none",
                children: /*#__PURE__*/ _jsx(Text, {
                    text: props.placeholder || 'Enter text',
                    size: 18,
                    lineHeight: 20,
                    color: "#c7c7c7",
                    role: "none"
                })
            })
        ]
    });
    return /*#__PURE__*/ _jsxs(View, {
        testID: "ChatInputText",
        style: {
            flexGrow: 1,
            maxHeight: 120,
            flexDirection: 'row',
            alignItems: 'center',
            marginHorizontal: 10
        },
        children: [
            Platform.OS === 'android' ? /*#__PURE__*/ _jsx(View, {
                accessible: true,
                "aria-label": [
                    state.isFocused ? 'Editing' : undefined,
                    value,
                    'Edit box',
                    props.lastTextContent
                ].filter(function(v) {
                    return !!v;
                }).join('.'),
                style: {
                    flexDirection: 'row',
                    flex: 1
                },
                accessibilityActions: [
                    {
                        name: 'activate',
                        label: state.isFocused ? 'blur' : 'focus'
                    }
                ],
                onAccessibilityAction: function(event) {
                    if (event.nativeEvent.actionName === 'activate') {
                        if (state.isFocused) {
                            var _inputRef_current;
                            (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.blur();
                        } else {
                            var _inputRef_current1;
                            (_inputRef_current1 = inputRef.current) === null || _inputRef_current1 === void 0 ? void 0 : _inputRef_current1.focus();
                        }
                    }
                },
                children: inner
            }) : inner,
            disabled ? null : /*#__PURE__*/ _jsx(Icon, {
                "aria-label": "send",
                color: valid ? theme.color.primary100 : theme.color.gray400,
                disabled: !valid || disabled,
                name: valid ? 'post-ready' : 'post-open',
                onPress: submit,
                size: 40,
                style: {
                    right: 2,
                    position: 'absolute'
                },
                testID: "ChatInputText_submit"
            })
        ]
    });
}
